import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import useRouter, { GeneViewRoute, } from 'Router/index';
import TableCellLink from '../TableCellLink/TableCellLink';
export const GeneTableCellLink = memo(function GeneTableCellLink({ geneName, traitsType, levelResult, label, referrerData, datasetVersionIdFromAPI, }) {
    /** @todo Change approach of getting data from router */
    const { getLocation, getParams } = useRouter();
    const { pathname } = getLocation();
    const { datasetVersionId: datasetVersionIdFromParams } = getParams();
    const datasetVersionId = datasetVersionIdFromAPI || datasetVersionIdFromParams;
    const geneViewPath = useMemo(() => (GeneViewRoute.getPath({
        traitsType,
        geneName,
        datasetVersionId,
        levelResult,
    })), [
        traitsType,
        geneName,
        datasetVersionId,
        levelResult,
    ]);
    const route = useMemo(() => ({
        pathname: geneViewPath,
        state: {
            referrerURI: pathname,
            referrerData,
        },
    }), [geneViewPath, pathname, referrerData]);
    return (_jsx(TableCellLink, { route: route, label: label || geneName, title: label || geneName }, void 0));
});
